import React from 'react';
import { Grid, Box, Typography } from '@material-ui/core';

function Infrustructure({ styles, data }) {
  return (
    <Box>
      {data.infrastructure ? (
        <Grid item xs={12}>
          <Box className={styles.sectionContainer}>
            <Box className={styles.section}>
              <Box className={styles.subSection}>
                <p className={styles.sectionText}>Infrastructure</p>
                <Typography
                  variant="body1"
                  className={styles.sectionSubTextNoWeight}>
                  {data.infrastructure.infrastructureDescription}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      ) : null}
    </Box>
  );
}

export default Infrustructure;
